import defaultColor from "@/components/color";

export default {
    cptDataForm:{
        dataSource: 1, pollTime: 0, dataText: '{"value":"1920"}',
    },
    attribute:{
        fontSize:50,padding:10,bgColor: defaultColor[1],color: '#ddd',borderRadius:0,fontFamily:'lccd',showSeparator:false,
        cptTableData:[{"name":"值","value":"","namekey":"value"}]
    },
    interaction:{intType: 'none'}
}
